var _path, _path2, _circle;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    id: "social-instagram-v2",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96,34.09c20.16,0,22.55.08,30.51.44,7.37.34,11.37,1.57,14,2.6a25,25,0,0,1,14.33,14.33c1,2.66,2.26,6.66,2.6,14,.36,8,.44,10.35.44,30.51s-.08,22.55-.44,30.51c-.34,7.37-1.57,11.37-2.6,14a25,25,0,0,1-14.33,14.33c-2.66,1-6.66,2.26-14,2.6-8,.36-10.35.44-30.51.44s-22.55-.08-30.51-.44c-7.37-.34-11.37-1.57-14-2.6a25,25,0,0,1-14.33-14.33c-1-2.66-2.26-6.66-2.6-14-.36-8-.44-10.35-.44-30.51s.08-22.55.44-30.51c.34-7.37,1.57-11.37,2.6-14A25,25,0,0,1,51.46,37.13c2.66-1,6.66-2.26,14-2.6,8-.36,10.35-.44,30.51-.44m0-13.61c-20.51,0-23.08.09-31.13.46s-13.53,1.64-18.34,3.51A38.64,38.64,0,0,0,24.45,46.53c-1.87,4.81-3.14,10.3-3.51,18.34S20.48,75.49,20.48,96s.09,23.08.46,31.13,1.64,13.53,3.51,18.34a38.64,38.64,0,0,0,22.08,22.08c4.81,1.87,10.3,3.14,18.34,3.51s10.62.46,31.13.46,23.08-.09,31.13-.46,13.53-1.64,18.34-3.51a38.64,38.64,0,0,0,22.08-22.08c1.87-4.81,3.14-10.3,3.51-18.34s.46-10.62.46-31.13-.09-23.08-.46-31.13-1.64-13.53-3.51-18.34a38.64,38.64,0,0,0-22.08-22.08c-4.81-1.87-10.3-3.14-18.34-3.51s-10.62-.46-31.13-.46Z",
    fill: "#ffffff",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96,57.22A38.78,38.78,0,1,0,134.78,96,38.78,38.78,0,0,0,96,57.22Zm0,64A25.17,25.17,0,1,1,121.17,96,25.17,25.17,0,0,1,96,121.17Z",
    fill: "#ffffff",
    stroke: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136.31,
    cy: 55.69,
    r: 9.06,
    fill: "#ffffff",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.3a250cae.svg";
export { ForwardRef as ReactComponent };